export default "__VITE_ASSET__C_9HhNSF__"